<template>
    <paper class="transferSystem">
        <m-pane
            ref="transferSystemRef"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            :currentPage="query.pageNo"
            searchId="transfer-system-query"
            pageID="transfer-system"
            @row-db-click="rowDBclick"
            @withdraw-btn="handleWithdrawBtn"
            @express-btn="handleExpressBtn"
            @actionLog-btn="handleActionLogBtn"
            @assignDriver-btn="handleAssignDriverBtn"
            @receiptUpload-btn="handleReceiptUploadBtn"
            @transferOrder-btn="handleTransferOrderBtn"
            @arrivalConfirmation-btn="arrivalConfirmation"
            @sizeChange="sizeChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
        >
            <template v-slot:customTableCell="{ row, col }">
                <div class="table-list-encrypted-panel">
                    <span>{{ row[col.prop] || '--' }}</span>
                    <i v-if="showEncryptEye(row, col)" class="el-icon-location-outline" @click.stop="openMapDialog(row, col)"></i>
                </div>
            </template>
            <div slot="table-module-btn">
                <el-tooltip effect='dark' content='导入' placement='bottom'>
                        <el-button icon='icon-daoru' size='mini' @click="showImport"></el-button>
                </el-tooltip>
            </div>

            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    @click="handleTransferOrder"
                    v-has="'otp04140006'"
                    >批量货站转单
                </el-button>

                <el-button
                    type="primary"
                    @click="handleWithdraw"
                    v-has="'otp04140007'"
                    >批量撤回
                </el-button>

                <el-button
                    type="primary"
                    @click="handleAssignDriver"
                    v-has="'otp04140008'"
                    >批量指派末端司机
                </el-button>
            </div>
        </m-pane>

        <!-- 货站转单 弹窗 -->
        <station-transfer-order-dialog
            ref="stationTransferOrderDialog"
            :rowData="currentRow"
            :consumerCode="consumerCode"
            :batchOperation="batchOperation"
            :MIPInfo="MIPInfo"
            v-if="transferOrderDialogVisible"
            :dialogVisible.sync="transferOrderDialogVisible"
            @handleClose="handleClose($event)"
            @handleSuccess="handleSuccess($event)"
        ></station-transfer-order-dialog>

        <!-- 指派末端司机 弹窗 -->
        <assign-driver-dialog
            ref="stationTransferOrderDialog"
            :rowData="currentData"
            :batchFlag="batchFlag"
            v-if="assignDriverDialog"
            :dialogVisible.sync="assignDriverDialog"
            @handleClose="handleClose($event)"
            @handleSuccess="handleSuccess($event)"
        ></assign-driver-dialog>

        <!-- 操作日志弹窗 -->
        <operation-log-dialog
            ref="configurationLogDialog"
            :rowData="rowData"
            :accountSign="MIPInfo.accountSign"
            v-if="logDialogVisible"
            :dialogVisible.sync="logDialogVisible"
            @handleClose="handleClose($event)"
        ></operation-log-dialog>

        <!-- 回单上传 弹框 -->
        <sign-in-dialog
            v-if="signInShow"
            :signInShow.sync="signInShow"
            :rowData="rowData"
            :query="query"
            @refreshList="getList"
            @handleClose="handleClose($event)"
        ></sign-in-dialog>

        <!-- 转快递 弹窗 -->
        <express-dialog
            ref="stationTransferOrderDialog"
            :rowData="rowData"
            v-if="expressDialog"
            :dialogVisible.sync="expressDialog"
            @handleClose="handleClose($event)"
            @handleSuccess="handleSuccess($event)"
        ></express-dialog>

        <map-dialog
            ref="mapDialog"
            v-if="mapDialog"
            :rowData="rowData"
            :dialogVisible.sync="mapDialog"
            @handleClose="handleClose($event)"
        ></map-dialog>

        <dispatch-shipTo
            res="dispatchShipTo"
            v-if="dispatchShipTo"
            :rowData="rowData"
            :dictData="dictData"
            :stationArriveInfo="stationArriveInfo"
            :dialogVisible.sync="dispatchShipTo"
            @handleClose="handleClose($event)"
        ></dispatch-shipTo>

        <!-- 导入 -->
        <Import
            ref="Import"
            :ImportConfig="importConfig.ImportConfig"
            :ImportContent="importConfig.ImportContent"
            :verifyConfig="importConfig.verifyConfig"
            @reflashList="getList"
        ></Import>
    </paper>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import mPane from '@/components/otpPanel';
import paper from '@/components/core/paper/Paper';
import DispatchShipTo from './components/dispatchShipTo/Index';
import mapDialog from './components/mapDialog/index';
import signInDialog from './components/receiptUploadDialog/SignInDetails';
import operationLogDialog from './components/operationLogDialog/Main';
import assignDriverDialog from './components/assignDriverDialog/Main';
import expressDialog from './components/expressDialog/Main';
import stationTransferOrderDialog from './components/stationTransferOrderDialog/Index';
import { formatSearchData, validateSearchData, messageTips, dealWithBtnShow } from './util.js';
import {
    getLoginAccount,
    recallTransferSystem,
    getStationSearchList,
    getTransferSystemList,
    getTransferSystemTotalData,
    queryStationArriveInfoByDispatchNo
} from '../../../api/transferSystem.js';
import { dictWithUrl } from '@/components/lots/api.js';
import Import from './components/expressDialog/import';
import importConfig from './components/expressDialog/config';
import config from './config.js';

export default {
    name: 'transferSystem',
    components: {
        paper,
        mPane,
        Import,
        mapDialog,
        signInDialog,
        expressDialog,
        DispatchShipTo,
        operationLogDialog,
        assignDriverDialog,
        stationTransferOrderDialog
    },
    data () {
        return {
            config,
            importConfig,
            pageTotal: 0,
            dictData: {},
            stationArriveInfo: {},
            loading: false,
            mapDialog: false,
            signInShow: false, // 回单上传 弹框显隐
            expressDialog: false, // 转快递 弹窗显隐
            dispatchShipTo: false,
            logDialogVisible: false, // 配置日志 弹窗显隐
            assignDriverDialog: false, // 指派末端司机 弹窗显隐
            transferOrderDialogVisible: false, // 货站转单 弹窗显隐
            batchOperation: false, // 货站转单 行操作/批量操作 标识符
            batchFlag: false, // 指派末端司机 行操作/批量操作 标识符
            operatorCode: '', // 当前登录人的MIP账号
            operatorName: '', // 当前登录人的MIP名称
            supplierCode: '', // 当前登录人的供应商编码
            stationCode: '', // 货站编码
            stationName: '', // 货站名称
            consumerCode: '', // 货站转单 货站高级搜索 需要的参数
            MIPInfo: {}, // 当前登录人的MIP信息
            rowData: {}, // 当前行数据
            currentRow: {}, // 货站转单 确认提交 需要的参数
            currentData: {}, // 指派末端司机 确认提交 需要的参数
            totalData: [], // 首页表格数据
            selected: [], // 选中的数据
            query: {
                pageNo: 1,
                pageSize: 10,
                orderBy: '1',
                orderByType: 'desc',
                param: {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                }
            },
        }
    },
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            supplier: state => state.supplier
        })
    },
    async created () {
        this.getDictList();
        this.operatorCode = this.user.userCode;
        this.operatorName = this.user.userName;
        this.supplierCode = this.supplier.supplierCode;
        await this.queryByMipID();
        await this.queryStationSearchList();
        this.addSearchCondition();
    },
    methods: {
        async getDictList () {
            // OTP_ARRIVAL_STATUS 运抵状态 00：已抵达  01：未抵达
            // OTP_STATION_ARRIVAL_WAY 抵达方式 01：直通宝手动抵达  02：pc手动抵达
            const res = await dictWithUrl('ANNTO_FORMWORK_OTP,OTP_STATION_ARRIVAL_WAY,OTP_ARRIVAL_STATUS');
            if (res) {
                this.dictData = res.data;
                this.importConfig.ImportContent[0].downLoadInfo.url = res.data.ANNTO_FORMWORK_OTP.FORWARD_EXPRESS_DELIVERY;
            }
        },
        showImport () {
            this.$nextTick(() => {
                this.$refs.Import.orderImportC();
            });
        },
        // 获取列表数据
        getList () {
            getTransferSystemList(this.query)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = this.formateTransferOrderData(res.data.list || []);
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        // 处理接口返回的数据 控制行操作 按钮显隐
        formateTransferOrderData (list) {
            list.forEach(item => {
                // 处理按钮显示条件
                item.hiddenEvent = dealWithBtnShow(item);
                // 是否已转单
                item.isTransfered = item.isTransfered === 'Y' ? '是' : '否';
                // 处理接口返回的数据 用于（数据字典）渲染
                item.signStatus = item.signStatus + '';
            });
            return list;
        },
        // 获取列表数据条数
        getListPageCount () {
            getTransferSystemTotalData(this.query.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },
        // 查询
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData, this.MIPInfo.accountSign);
            if (!isQueryOk) return;
            this.query = this.getSearchData(_searchData);
            this.getList();
            this.getListPageCount();
        },
        // 组装查询参数
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                param: {
                    supplierCode: this.supplierCode,
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    ...data
                }
            };
            return _searchData;
        },
        // 查询 当前登录人的MIP账号 是承运商还是货站    承运商为 0  承运商为 1
        async queryByMipID () {
            await getLoginAccount({ mipAccount: this.operatorCode })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.MIPInfo = res.data || {};
                    } else {
                        this.$message.warning(res.msg || '查询账号信息失败');
                    }
                })
                .catch(() => { })
        },
        // 判断 是否为供应商 如果是供应商 添加 货站名称 搜索条件
        addSearchCondition () {
            if (+this.MIPInfo.accountSign === 1) {
                // 判断配置文件的长度 避免重复添加
                if (this.config.searchList.searchTxt.length === 3) {
                    this.config.searchList.searchTxt.push({
                        name: "货站名称",
                        value: "stationName",
                        type: "advance",
                        unfold: true,
                        advanceConfig: [
                            { prop: 'stationName', value: '货站名称' },
                            { prop: 'stationCode', value: '货站编码' }
                        ],
                        tableConfig: [
                            { prop: 'stationCode', value: '货站编码' },
                            { prop: 'stationName', value: '货站名称' },
                            { prop: 'contactsName', value: '货站联系人姓名' },
                            { prop: 'contactsMobile', value: '货站联系人电话' },
                            { prop: 'supplierName', value: '承运商名称' },
                            { prop: 'supplierCode', value: '承运商编码' },
                        ],
                        method: 'post',
                        paramType: true,
                        prefix: '/api-antms/transport',
                        advanceUrl: "/lsp/transfer/getStationList",
                        cbParams: ['stationCode#stationCode', 'stationName#stationName', 'contactsName', 'contactsMobile', 'supplierCode','supplierName'],
                        advanceCascade: 'mipAccount#mipAccount',
                        span: 5
                    })
                }
                this.$nextTick(() => {
                    // 配置货站名称搜索条件的传参以及默认值
                    this.$refs.transferSystemRef.$refs.searchList.searchData = {
                        mipAccount: this.operatorCode, stationName: this.stationName,
                        stationCode: this.stationCode
                    }
                    // 解决 货站名称 点击清空icon 不生效的问题
                    this.$refs.transferSystemRef.$refs.searchList.keyMap = {
                        stationName: ['stationCode','stationName'],
                        stationCode: ['stationCode', 'stationName']
                    }
                    // 避免刷新时 增加的搜索条件 不显示 的bug
                    this.$refs.transferSystemRef.$refs.searchList.searchList.unfoldList = this.config.searchList.searchTxt;
                })
            }
        },
        // 查询货站高级搜索类表数据
        async queryStationSearchList () {
            const params = {
                pageNo: 1,
                pageSize:10,
                param: {
                    mipAccount: this.operatorCode
                }
            }
        // 获取货站名称高级搜索的数据 取第一条 作为默认值
        await getStationSearchList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                    this.stationName = res.data.list[0].stationName || '';
                    this.stationCode = res.data.list[0].stationCode || ''
                    }
                })
                .catch(() => { });
        },
        // 批量操作 是否选中数据的消息提示
        decideSelectData () {
            if (this.selected.length < 1) {
                this.$message.warning('至少勾选一条数据进行操作');
                return false;
            }
            return true;
        },
        // 校验是否获取到 当前登录账号的 信息
        async validateOperatorCode () {
            // 判断该账号的 承运商编码 是否存在
            if (this.supplierCode === '') {
                this.$message.warning('无法获取该账号的承运商编码');
                return;
            };
            // 校验是否 获取到账户信息
            if (this.MIPInfo.hasOwnProperty('accountSign')) {
                return true;
            } else {
            // 重新获取 账号信息
            await   this.queryByMipID();
                this.$message.warning('操作失败')
                return false;
            }
        },
        // 是否展示定位icon
        showEncryptEye (row, col) {
            if (row.arrivalDriverAddress) {
                return true;
            }
        },
        // 点击定位icon，打开定位弹窗
        openMapDialog (row, col) {
            this.rowData = row;
            this.mapDialog = true;
        },
        // 行操作 货站运抵
        arrivalConfirmation (data) {
            this.rowData = data;
            queryStationArriveInfoByDispatchNo({ dispatchNo: data.dispatchNo })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.stationArriveInfo = res.data;
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.dispatchShipTo = true;
                });
        },
        // 行操作 货站转单
        handleTransferOrderBtn (rowData) {
            if (this.validateOperatorCode()) {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: rowData.dispatchNo,
                    customerOrderNo: rowData.customerOrderNo,
                    // transportType  转单类型（1-承运商转货站/2-货站转货站/3-扫码转单/4-承运商指派末端司机/5-货站指派末端司机
                    transportType: this.MIPInfo.accountSign === '0' ? '1' : '2',
                    taskNoList: [rowData.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                this.currentRow = +this.MIPInfo.accountSign === 1 ?
                    Object.assign({}, data, {
                        supplierName: '',
                        supplierCode: '',
                        outStationName: this.query.param.stationName || '',
                        outStationCode: this.query.param.stationCode || '',
                    }) :
                    Object.assign({}, data, {
                        supplierName: this.operatorName || '',
                        supplierCode: this.supplierCode || '',
                        outStationName: '',
                        outStationCode: '',
                    });
                // 货站转单 批量操作的标识
                this.batchOperation = false;
                // 货站转单内 货站高级搜索 需要的参数
                this.consumerCode = rowData.carrierCode;
                // 打开货站转单弹窗
                this.transferOrderDialogVisible = true;
            }
        },
        // 行操作 撤回
        handleWithdrawBtn (rowData) {
            if (this.validateOperatorCode()) {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: rowData.dispatchNo,
                    customerOrderNo: rowData.customerOrderNo,
                    // withdrawType  撤回类型（1-承运商撤回/2-货站撤回）
                    withdrawType: this.MIPInfo.accountSign === '0' ? '1' : '2',
                    taskNoList: [rowData.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                const params = +this.MIPInfo.accountSign === 1 ?
                    Object.assign({}, data, {
                        supplierCode: '',
                        supplierCode: '',
                        stationCode: this.query.param.stationCode || '',
                        stationName: this.query.param.stationName || '',
                        currentStationCode: rowData.lspTransferStationCode || '',
                        currentStationName: rowData.lspTransferStationName || ''
                    }) :
                    Object.assign({}, data, {
                        supplierCode: this.supplierCode || '',
                        supplierName: this.operatorName || '',
                        stationCode: '',
                        stationName: '',
                        currentStationCode: rowData.lspTransferStationCode || '',
                        currentStationName: rowData.lspTransferStationName || ''
                    });
                messageTips('此操作将永久撤回该数据, 是否继续？', recallTransferSystem, [params], '撤回成功', this);
            }
        },
        // 行操作 指派末端司机
        handleAssignDriverBtn (rowData) {
            if (this.validateOperatorCode()) {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: rowData.dispatchNo,
                    customerOrderNo: rowData.customerOrderNo,
                    // transportType  转单类型（1-承运商转货站/2-货站转货站/3-扫码转单/4-承运商指派末端司机/5-货站指派末端司机
                    transportType: this.MIPInfo.accountSign === '0' ? '4' : '5',
                    taskNoList: [rowData.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                this.currentData = +this.MIPInfo.accountSign === 1 ?
                    Object.assign({}, data, {
                        supplierName: '',
                        supplierCode: '',
                        outStationName: this.query.param.stationName || '',
                        outStationCode: this.query.param.stationCode || '',
                    }) :
                    Object.assign({}, data, {
                        supplierName: this.operatorName || '',
                        supplierCode: this.supplierCode || '',
                        outStationName: '',
                        outStationCode: '',
                    });
                // 指派末端司机 批量操作的标识
                this.batchFlag = false;
                // 打开指派末端司机的弹窗
                this.assignDriverDialog = true;
            }
        },
        // 行操作 回单上传 打开弹窗
        handleReceiptUploadBtn (rowData) {
            this.rowData = rowData;
            this.signInShow = true;
        },
        // 批量 货站转单
        handleTransferOrder () {
            // 校验是否选中数据 && 校验是否获取到 当前登录账号的 信息
            if (this.decideSelectData() && this.validateOperatorCode()) {
                // 校验选中的数据 承运商编码 是否一致
                if (this.selected.some(v => v.carrierCode !== this.selected[0].carrierCode)) {
                    return this.$message.warning('选中的数据，必须为同一承运商的订单');
                }
                // 过滤出不可以操作的数据
                const warningCustomerOrderNo = this.selected.filter(item => +item.transportFlag === 1);
                // 如果存在 不可以操作的数据 将对应的客户订单号提示出来 并不可以进行操作
                if (warningCustomerOrderNo.length > 0) {
                    const warningTips = warningCustomerOrderNo.map(item => item.customerOrderNo).join(',');
                    return this.$message.warning(`客户订单号为：${warningTips} 的订单，不可以进行转单操作`);
                }
                // 货站转单 批量操作的标识符
                this.batchOperation = true;
                // 货站转单内 货站高级搜索 需要的参数
                this.consumerCode = this.selected[0].carrierCode;
                // 组装 批量货站转单参数
                this.currentRow = this.setTransferOrderParams(this.selected);
                // 打开 货站转单 弹窗
                this.transferOrderDialogVisible = true;
            }
        },
        // 组装 批量货站转单参数
        setTransferOrderParams (list) {
            let listData = list.map(item => {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: item.dispatchNo,
                    customerOrderNo: item.customerOrderNo,
                    // transportType  转单类型（1-承运商转货站/2-货站转货站/3-扫码转单/4-承运商指派末端司机/5-货站指派末端司机
                    transportType: this.MIPInfo.accountSign === '0' ? '1' : '2',
                    taskNoList: [item.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                const concatData = +this.MIPInfo.accountSign === 1 ?
                    {
                        supplierName: '',
                        supplierCode: '',
                        outStationName: this.query.param.stationName || '',
                        outStationCode: this.query.param.stationCode || '',
                        ...data
                    } :
                    {
                        supplierName: this.operatorName || '',
                        supplierCode: this.supplierCode || '',
                        outStationName: '',
                        outStationCode: '',
                        ...data
                    };
                return concatData
            })
            return listData;
        },
        // 批量 撤回
        handleWithdraw () {
            if (this.decideSelectData() && this.validateOperatorCode()) {
                // 过滤出不可以操作的数据
                const warningCustomerOrderNo = this.selected.filter(item => +item.withdrawFlag === 1);
                if (warningCustomerOrderNo.length > 0) {
                    // 如果存在 不可以操作的数据 将对应的客户订单号提示出来 并不可以进行操作
                    const warningTips = warningCustomerOrderNo.map(item => item.customerOrderNo).join(',');
                    this.$message.warning(`客户订单号为：${warningTips} 的订单，不可以进行撤回操作`)
                    return;
                }
                const params = this.setWithdrawParams(this.selected);
                messageTips('此操作将批量撤回选中的数据, 是否继续？', recallTransferSystem, params, '撤回成功', this);
            }
        },
        // 组装 批量撤回 参数
        setWithdrawParams (list) {
            let listData = list.map(item => {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: item.dispatchNo,
                    customerOrderNo: item.customerOrderNo,
                    // withdrawType  撤回类型（1-承运商撤回/2-货站撤回）
                    withdrawType: this.MIPInfo.accountSign === '0' ? '1' : '2',
                    taskNoList: [item.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                const concatData = +this.MIPInfo.accountSign === 1 ?
                    {
                        supplierCode: '',
                        supplierName: '',
                        stationCode: this.query.param.stationCode || '',
                        stationName: this.query.param.stationName || '',
                        currentStationCode: item.lspTransferStationCode || '',
                        currentStationName: item.lspTransferStationName || '',
                        ...data
                    } :
                    {
                        supplierCode: this.supplierCode || '',
                        supplierName: this.operatorName || '',
                        stationCode: '',
                        stationName: '',
                        currentStationCode: item.lspTransferStationCode || '',
                        currentStationName: item.lspTransferStationName || '',
                        ...data
                    };
                return concatData;
            })
            return listData;
        },
        // 批量 指派末端司机
        handleAssignDriver () {
            if (this.decideSelectData() && this.validateOperatorCode()) {
                // 过滤出不可以操作的数据
                const warningCustomerOrderNo = this.selected.filter(item => +item.assignDriverFlag === 1);
                if (warningCustomerOrderNo.length > 0) {
                    // 如果存在 不可以操作的数据 将对应的客户订单号提示出来 并不可以进行操作
                    const warningTips = warningCustomerOrderNo.map(item => item.customerOrderNo).join(',');
                    return this.$message.warning(`客户订单号为：${warningTips} 的订单，不可以进行指派末端司机操作`);
                }
                // 指派末端司机 批量操作的标识
                this.batchFlag = true;
                // 组装 批量指派末端司机 参数
                this.currentData = this.setAssignDriverParams(this.selected);
                // 打开 指派末端司机 弹窗
                this.assignDriverDialog = true;
            }
        },
        // 组装 批量指派末端司机 参数
        setAssignDriverParams (list) {
            let listData = list.map(item => {
                const data = {
                    platform: 'PC', // platform 系统平台 PC / ZTB 直通宝
                    operatorCode: this.operatorCode,
                    operatorName: this.operatorName,
                    dispatchNo: item.dispatchNo,
                    customerOrderNo: item.customerOrderNo,
                    // transportType  转单类型（1-承运商转货站/2-货站转货站/3-扫码转单/4-承运商指派末端司机/5-货站指派末端司机
                    transportType: this.MIPInfo.accountSign === '0' ? '4' : '5',
                    taskNoList: [item.taskNo].filter(Boolean)
                }
                // 通过判断 该账号 使用不同的 字段 传参，并传递 不同的参数
                const concatData = +this.MIPInfo.accountSign === 1 ?
                    {
                        supplierName: '',
                        supplierCode: '',
                        outStationName: this.query.param.stationName || '',
                        outStationCode: this.query.param.stationCode || '',
                        ...data
                    } :
                    {
                        supplierName: this.operatorName || '',
                        supplierCode: this.supplierCode || '',
                        outStationName: '',
                        outStationCode: '',
                        ...data
                    };
                return concatData
            })
            return listData;
        },
        // 行操作 转快递
        handleExpressBtn (data) {
            this.rowData = data;
            this.expressDialog = true;
        },
        // 操作日志弹窗
        handleActionLogBtn (data) {
            this.rowData = data;
            this.logDialogVisible = true;
        },
        // 关闭弹窗
        handleClose (dialogName) {
            this[dialogName] = false;
            this.getList();
        },
        // 弹窗 成功的回调
        handleSuccess (dialogName) {
            this[dialogName] = false;
            this.getList();
        },
        // 双击事件
        rowDBclick () { },
        // 表格数据选中
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },
        // 切换当前分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    }
}
</script>
<style lang="less" scoped>
.table-list-encrypted-panel {
    .el-icon-location-outline {
        font-size: 15px;
        cursor: pointer;
        margin-left: 5px;
        color: #00BCBF;
    }
}
</style>
